import { Link } from "react-router-dom";
import "./styles/BlockedUsers.scss";

// Issue #126: マイページからブロック一覧（/blocked-users）への導線
const BlockedUsersLink = () => {
  return (
    <div className="blocked-users-link">
      <Link to="/blocked-users" className="blocked-users-link__anchor">
        ブロックしたユーザー
      </Link>
    </div>
  );
};

export default BlockedUsersLink;
